(function () {
  function getSelectedOption(select) {
    if (!select) {
      return null;
    }

    var option = null;

    if (select.selectedOptions && select.selectedOptions.length) {
      option = select.selectedOptions[0];
    } else if (typeof select.selectedIndex === 'number' && select.selectedIndex >= 0) {
      option = select.options[select.selectedIndex];
    }

    return option && option.value ? option : null;
  }

  function updateCard(section, card) {
    var select = card.querySelector('[data-compare-select]');
    var option = getSelectedOption(select);
    var emptyValue = section.dataset.emptyValue || '-';

    var link = card.querySelector('[data-compare-link]');
    var title = card.querySelector('[data-compare-title]');
    var price = card.querySelector('[data-compare-price]');
    var cta = card.querySelector('[data-compare-cta]');

    var image = card.querySelector('[data-compare-image]');
    var placeholder = card.querySelector('.comparison-product__image-placeholder');

    var columnIndex = card.dataset.columnIndex;
    var cells = section.querySelectorAll('[data-spec-cell][data-column-index="' + columnIndex + '"]');

    var nextTitle = option ? option.dataset.title : (select.options[0] ? select.options[0].textContent : '');
    var nextUrl = option ? option.dataset.url : '#';
    var nextPrice = option ? option.dataset.price : emptyValue;
    var nextImage = option ? option.dataset.image : '';

    if (title) {
      title.textContent = nextTitle;
    }

    if (price) {
      price.textContent = nextPrice;
    }

    if (link) {
      link.href = nextUrl;
      link.setAttribute('aria-label', nextTitle || '');
    }

    if (cta) {
      cta.href = nextUrl;
      cta.setAttribute('aria-disabled', option ? 'false' : 'true');
    }

    if (image) {
      if (nextImage) {
        image.src = nextImage;
        image.alt = nextTitle || '';
        image.hidden = false;
        if (placeholder) {
          placeholder.style.display = 'none';
        }
      } else {
        image.src = '';
        image.alt = '';
        image.hidden = true;
        if (placeholder) {
          placeholder.style.display = '';
        }
      }
    }

    cells.forEach(function (cell) {
      var specIndex = cell.dataset.specIndex;
      var value = '';

      if (option) {
        value = option.getAttribute('data-spec-' + specIndex) || option.dataset['spec' + specIndex] || '';
      }

      cell.textContent = value || emptyValue;
    });
  }

  function syncDisabledOptions(section) {
    var selects = Array.prototype.slice.call(section.querySelectorAll('[data-compare-select]'));

    var selectedValues = selects
      .map(function (select) {
        return select.value;
      })
      .filter(function (value) {
        return value;
      });

    selects.forEach(function (select) {
      Array.prototype.slice.call(select.options).forEach(function (option, index) {
        if (index === 0) {
          option.disabled = false;
          return;
        }

        var selectedElsewhere = selectedValues.indexOf(option.value) !== -1 && select.value !== option.value;
        option.disabled = selectedElsewhere;
      });
    });
  }

  function ensureInitialSelection(section) {
    var selects = Array.prototype.slice.call(section.querySelectorAll('[data-compare-select]'));
    var hasDefaultSelection = false;

    selects.forEach(function (select) {
      var defaultId = select.dataset.defaultId;
      if (defaultId && select.querySelector('option[value="' + defaultId + '"]')) {
        select.value = defaultId;
        hasDefaultSelection = true;
      }
    });

    if (!hasDefaultSelection) {
      var pool = [];

      selects.forEach(function (select) {
        Array.prototype.slice.call(select.options).forEach(function (option, index) {
          if (index === 0 || !option.value || pool.indexOf(option.value) !== -1) {
            return;
          }
          pool.push(option.value);
        });
      });

      for (var i = pool.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = pool[i];
        pool[i] = pool[j];
        pool[j] = temp;
      }

      selects.forEach(function (select, index) {
        if (!select.value && pool[index] && select.querySelector('option[value="' + pool[index] + '"]')) {
          select.value = pool[index];
        }
      });
    }

    selects.forEach(function (select) {
      if (select.value) {
        return;
      }

      for (var i = 1; i < select.options.length; i += 1) {
        if (!select.options[i].disabled) {
          select.value = select.options[i].value;
          break;
        }
      }
    });

    syncDisabledOptions(section);
  }

  function initSection(section) {
    var cards = section.querySelectorAll('[data-comparison-select-card]');
    if (!cards.length) {
      return;
    }

    ensureInitialSelection(section);

    cards.forEach(function (card) {
      updateCard(section, card);

      var select = card.querySelector('[data-compare-select]');
      if (!select) {
        return;
      }

      function handleSelectionUpdate() {
        syncDisabledOptions(section);
        cards.forEach(function (item) {
          updateCard(section, item);
        });
      }

      select.addEventListener('change', handleSelectionUpdate);
      select.addEventListener('input', handleSelectionUpdate);
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-product-comparison]');
    if (!sections.length) {
      return;
    }

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
